<template>
  <div class="quest-username-form">
    <form @submit.prevent="submitForm" class="quest-username-form__form">
      <div class="quest-username-form__form-group mb-24">
        <label for="username" class="quest-username-form__label">Username</label>
        <input
          ref="usernameInput"
          v-model="username"
          type="text"
          id="username"
          placeholder="e.g. Agent Cooper"
          class="quest-username-form__input"
          :class="{
            'quest-username-form__input--error': inputState === 'error',
            'quest-username-form__input--success': inputState === 'success',
            'quest-username-form__input--shake': isShaking
          }"
          :disabled="formDisabled"
        />
      </div>

      <div class="quest-username-form__submit-container">
        <button
          type="submit"
          class="btn btn--xxl quest-username-form__submit"
          :disabled="formDisabled || username.length === 0"
        >
          {{ formDisabled ? 'Saving...' : 'Start Quest' }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { notify } from "modules/notify";

export default {
  name: "QuestUsernameForm",
  data() {
    return {
      username: "",
      errors: [],
      formDisabled: false,
      briefingUrl: window.state.briefingUrl,
      inputState: null, // 'error', 'success', or null
      isShaking: false
    };
  },
  methods: {
    triggerShake() {
      this.isShaking = true;
      setTimeout(() => {
        this.isShaking = false;
      }, 500);
    },
    validateForm() {
      this.errors = [];

      if(this.username.trim().length === 0) {
        notify({
          message: "Username can't be blank",
          type: "error"
        });

        this.formDisabled = false;
        this.inputState = 'error';
        this.triggerShake();

        return false;
      }

      if(this.username.length < 2) {
        notify({
          message: "Username is too short (minimum is 2 characters)",
          type: "error"
        });

        this.formDisabled = false;
        this.inputState = 'error';
        this.triggerShake();

        return false;
      }

      return true;
    },
    submitForm() {
      if(this.formDisabled) {
        return;
      }

      if(!this.validateForm()) {
        return false;
      }

      this.formDisabled = true;
      this.errors = [];

      let formData = new FormData();
      formData.append("username", this.username);

      axios.patch("/api/users/update_username", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
        }
      }).then(response => {
        this.inputState = 'success';

        notify({
          message: "Username saved successfully!"
        });

        window.location = this.briefingUrl;
      }).catch(error => {
        const errors = error.response?.data?.errors || [];

        errors.forEach(error => {
          notify({
            message: error,
            type: "error"
          });
        });

        this.inputState = 'error';
        this.triggerShake();
        this.formDisabled = false;
      });
    }
  },
  mounted() {
    this.$refs.usernameInput.focus();
  }
}
</script>

<style lang="scss">
.quest-username-form {
  &__errors {
    padding: $px16;

    border: $px2 solid $red-5;
    border-radius: $px4;

    background-color: $red-10;
  }

  &__error {
    color: $red-5;

    @include font-regular;

    & + & {
      margin-top: $px8;
    }
  }

  &__form {
    width: 100%;
  }

  &__form-group {
    display: flex;
    flex-direction: column;
  }

  &__label {
    margin-bottom: $px8;

    @include font-label;
  }

  &__input {
    padding: $px16;

    border: $px2 solid $grey-8;
    border-radius: $px4;

    @include font-regular;
    font-size: 18px;

    outline: none;

    &::placeholder {
      color: $grey-7;
    }

    &:focus {
      border-color: $blue-5;
    }

    &--error {
      border-color: $red-7;
    }

    &--success {
      border-color: $green-7;
    }

    &--shake {
      animation: horizontal-tooltip-shake 1s cubic-bezier(.36, .07, .19, .97) both;
    }

    &:disabled {
      background-color: $grey-10;
      cursor: not-allowed;
    }
  }

  &__submit-container {
    display: flex;
    justify-content: flex-end;
  }

  &__submit {
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
